import React, { Component } from 'react';

import { TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { IconTypes } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';
import List from '../List';

import styles from './GroupCard.styles';

class GroupCard extends Component {
  onListItemPress = item => {
    this.props.onPressDiscoverListItem(item);
  };

  mapItems = (items = []) => {
    return items.map(item => {
      item.onPress = () => this.onListItemPress({ ...item });
      item.leftIconType = IconTypes.image;
      item.leftIconName = item.extraInfo.icon;
      item.title = item.extraInfo.title;

      item.itemAccessibilityLabel = item.containerAccessibilityLabel || FrameworkTestKeys.GroupCard;
      item.itemIconAccessibilityLabel =
        item.leftIconAccessibilityLabel || FrameworkTestKeys.GroupCardIcon;
      item.itemTitleAccessibilityLabel =
        item.titleAccessibilityLabel || FrameworkTestKeys.GroupCardTxt;
      item.itemRightIconAccessibilityLabel =
        item.rightIconAccessibilityLabel || FrameworkTestKeys.GroupCardArrow;

      item.leftIconSize = 24;
      item.showRightIcon = true;
      item.rightIconType = IconTypes.image;
      item.rightIconName = 'ic_chevron_right_red';
      item.rightIconSize = 20;
      item.rightIconStyle = styles.listItemRightIconStyle;
      item.containerStyle = styles.listItemContainerStyle(this.props.theme);
      item.textStyle = styles.listItemTextStyle(this.props.theme);

      return item;
    });
  };

  render() {
    return (
      this.props.items?.length > 0 && (
        <List
          title={this.props.header}
          items={this.mapItems(this.props.items)}
          style={styles.listStyle}
          headerContainerStyle={styles.headerContainerStyle(this.props.theme)}
          images={this.props.images}
          viewAccessibilityLabel={this.props.viewAccessibilityLabel}
          listTitleAccessibilityLabel={this.props.listTitleAccessibilityLabel}
          itemsAccessibilityLabel={this.props.itemsAccessibilityLabel}
          moreText={this.props.moreText}
          lessText={this.props.lessText}
          itemName={this.props.itemName}
          headerStyle={this.props.headerStyle}
        />
      )
    );
  }
}

GroupCard.defaultProps = {
  theme: LightThemeColors,
};

GroupCard.propTypes = {
  header: PropTypes.string.isRequired,
  moreText: PropTypes.string.isRequired,
  lessText: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      componentId: PropTypes.string.isRequired,
      extraInfo: PropTypes.shape({
        title: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
      }).isRequired,
    }),
  ).isRequired,
  viewAccessibilityLabel: PropTypes.string,
  itemName: PropTypes.string,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  images: PropTypes.object,
  listTitleAccessibilityLabel: PropTypes.string,
  itemsAccessibilityLabel: PropTypes.string,
  onPressDiscoverListItem: PropTypes.func,
  headerStyle: TextPropTypes.style,
};

export default withTheme(GroupCard);
